import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs';
import { DateTime } from 'luxon';
import { Valid } from 'luxon/src/_util';
/* eslint-disable @typescript-eslint/no-explicit-any*/

export const dateTimeInterceptor: HttpInterceptorFn = (req, next) => next(req).pipe(tap((httpEvent) => {
    if (httpEvent instanceof HttpResponse) {
        convertTimestampsToDateTimeType(httpEvent.body);
    }
}))
const isoDateFormat = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;

function isIsoDateString(value: any): boolean {
    return typeof value === 'string' ? isoDateFormat.test(value) : false;
}

function convertTimestampsToDateTimeType(body: any): any {
    if (body === null || body === undefined || typeof body !== 'object') {
        return;
    }
    for (const key of Object.keys(body)) {
        if (isIsoDateString(body[key])) {
            body[key] = <DateTime<Valid>>DateTime.fromISO(body[key]);
        } else if (typeof body[key] === 'object') {
            convertTimestampsToDateTimeType(body[key]);
        }
    }
}
